<template>
	<i
		:class="[`icon`, `icon-${type}`]"
		:role="ariaLabel ? 'img' : null"
		:aria-label="ariaLabel"
		:aria-hidden="!ariaLabel ? 'true' : null"
	/>
</template>

<script>
export default {
	name: "Icon",
	props: {
		/**
		 * Icon type
		 *
		 * @values down, left, right, up, bold-up, bold-down, arrow-down, arrow-up, download, return, share, person, check, plus, close, lock, star, menu, calendar, date, search, cart, chart, list, mail, phone, play, audio, video, document, documents, news, print, info, email, chat, factsheet, refresh, reset, info_outline, filter_list, warning, eye, eye-blocked, bin, arrow-up-right, clear, facebook, twitter, linkedin, rss, podcast
		 */
		type: {
			type: String,
			required: true
			// do not validate this, since there could be more icons going forward (using this font)
		},

		/**
		 * Icon accessibility description
		 */
		ariaLabel: {
			type: String
		}
	}
};
</script>
